/* eslint-disable max-len */
/* eslint-disable vue/max-len */

import * as pbm from '@/grpc-gen/giftcard_pb';

export default class GiftcardRecipient {
  name?: string;

  email?: string;

  dtDelivery?: Date;

  giftcardMessage?: string;

  static fromGrpcModel(o?: pbm.GiftcardRecipient, m?: any): GiftcardRecipient {
    const p = new GiftcardRecipient();

    p.email = o?.email || undefined;
    p.name = o?.name || undefined;
    p.dtDelivery = o?.dtDelivery ? new Date(Number(o.dtDelivery) * 1000) : undefined;
    p.giftcardMessage = o?.giftcardMessage || undefined;

    return p;
  }
}
